import React from 'react'
import { Link } from 'react-router-dom'

function Victory() {
    return (
        <div className=' font-thin'>
              <div className="w-full px-6 md:px-16  mx-auto  max-w-7xl">
    
    {/* ✅ Breadcrumb Navigation */}
    <div className="flex justify-start text-sm md:text-base">
           <Link to="/" className="block py-1 pl-4 hover:underline  mt-6">Home -</Link>
           <Link to="/mainhomemodel" className="block py-1 pl-4 hover:underline mt-6">Typologies -</Link>
           <Link to="/semiverticals" className="block py-1 pl-4 hover:underline mt-6">Semi Verticals -</Link>
           <span className="block py-1 pl-4 mt-6">VICTORY</span>
    
         </div>
         {/* ✅ Product Image on Top */}
         <div className="flex justify-center mb-6">
           <img src="/images/VICTORY1.png" alt="Vista" className="max-w-full h-auto object-contain" />
         </div>
    
         {/* ✅ Product Title & Description */}
         <div className="text-center mb-6">
           <h1 className="text-3xl md:text-4xl uppercase mb-8">VICTORY</h1>
           <p className="text-xl lg:text-2xl font-thin max-w-sm mx-auto text-gray-500">The right choice for grab’n’go sales and promotional actions.</p>
           <p className="text-xl lg:text-2xl font-thin opacity-80 max-w-7xl mx-auto text-gray-500 mt-10">The new grab’n’go VICTORY is a very competitive merchandiser for self-service of pre-packed foods and beverages. Available as 72 cm and 84 cm deep, it adapts and maximizes to the most to your store space and needs.</p>
         </div>
    
         {/* ✅ Models & Model Values */}
    <h2 className="text-3xl font-thin opacity-80 text-gray-500 mb-8 text-center ">Models</h2>
    
    <div className="grid grid-cols-1 gap-4 text-center mb-6">

       <p className="text-xl lg:text-2xl opacity-90">PRE-PACKED FOODS & BEVERAGES <span className=' text-blue-500'> -1… +7 °C</span> (3M2)</p>
      
    </div>

         {/* ✅ Refrigeration */}
         <div>
           <h2 className="text-3xl font-thin text-center mt-10 text-gray-500 ">Refrigeration</h2>
         
           <p className="text-xl lg:text-2xl text-lime-500 text-center mt-6">CO2 | Glicol | R290</p>

         </div>
    
   


         {/* ✅ Case Images & Features */}
         <div className="flex flex-col gap-8 md:pt-32">
            {/* case 1 */}
             <div 
               className="flex flex-col  md:pb-16 md:mt-20 md:flex-row-reverse gap-6" >
                 {/* ✅ Image Wrapper */}
                 <div className="w-full md:w-1/2">
                 <img src="/images/victorycase.jpg" className="max-w-full h-auto object-contain" />
                 <img src="/images/victorycase1.png" className="max-w-full h-auto object-contain" />
                 <img src="/images/victorycase2.png" className="max-w-full h-auto object-contain" />

               </div>
               {/* ✅ Case Points */}
               <div className="w-full md:w-1/2 px-4">
    <p className="text-xl md:text-4xl">High capacity and maximum visibility for your fresh foods & beverages!</p>
    <ul className="list-[square] list-outside text-gray-500">
  <li className="text-xl font-thin opacity-90 mt-6">
    Up to 4 display levels, height adjustable and tiltable shelves.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Ventilated refrigeration for an even temperature distribution.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Available in 2 depths 72 cm or 84 cm.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Panoramic double-glazed glass end panels for increased energy efficiency.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Canopy with high-bright LED lighting.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Auto-rewinding night blind.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Casters for easy repositioning inside the store (optional).
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Undershelf LED lighting (optional).
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Stainless steel or white finish.
  </li>
  <li className="text-xl font-thin opacity-90 mt-6">
    Available as plug-in and remote condensing unit models.
  </li>
</ul>



</div>
                
             </div>
         </div>
    
   
     </div>
    
  
        </div>
      )
    }

export default Victory